import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { EventStatistics } from '~types/api/eventStatistics';
import { useUserStore } from '~providers/userStore/zustand';

export function useGetEventStatistics(shouldFetch = true) {
  const token = useUserStore(state => state.token);

  return useQuery<EventStatistics | undefined, Error>(
    ['eventStatistics'],
    async () => {
      if (!token) {
        console.log('🔍 useGetEventStatistics: Missing token');
        return undefined;
      }

      const response = await fetch(`${BASE_API_URL}users/event-statistics`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to get event statistics: ${response.status}`);
      }

      const data = (await response.json()) as EventStatistics;
      return data;
    },
    {
      enabled: shouldFetch && !!token,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}
